export default {
  'pl-pokoje': {
    pokoj: 'Pokój',
    pokoj_s: 'pokój',
    pokoje: 'Pokoje',
    pokoju: 'pokoju',
    pokojami: 'pokojami',
    pokoi_s: 'pokoi'
  },
  'pl-domki': {
    pokoj: 'Domek',
    pokoj_s: 'domek',
    pokoje: 'Domki',
    pokoju: 'domku',
    pokojami: 'domkami',
    pokoi_s: 'domków'
  },
  'pl-stoliki': {
    pokoj: 'Stolik',
    pokoj_s: 'stolik',
    pokoje: 'Stoliki',
    pokoju: 'stolika',
    pokojami: 'stolikami',
    pokoi_s: 'stolików'
  },
  'pl-autokary': {
    pokoj: 'Autokar',
    pokoj_s: 'autokar',
    pokoje: 'Autokary',
    pokoju: 'autokaru',
    pokojami: 'autokarami',
    pokoi_s: 'autokarów'
  }
}
